<!--  -->
<template>
    <div class='contactRow'>
        <div class='content box contactContent'>
            <div class="contactUs">
                <div class="contactTitle">联系我们</div>
                <div class="contactSubTitle">北京北科互联城市治理技术研究院有限公司</div>
                <div class="contactSubTitle">商务合作邮箱：bkcc@bkcc.com.cn</div>
                <div class="contactSubTitle">联系电话：010-84870893</div>
                <div class="contactSubTitle">地址：北京市朝阳区北苑路32号安全大厦</div>
            </div>
            <div class="contactcenter" v-if="!isPhone" ref="contactcenter">
                <div class="contactTitle">更多服务</div>
                <div class="contactSubTitle">OA系统 | 企业微信</div>
                <div class="contactSubTitle">智能感知城市治理系统</div>
            </div>
            <div v-if="!isPhone">
                <img :src="wxsrc" class="wxcode"/>
                <div class="tip">官方微信</div>
            </div>
        </div>
        <a class="icp" target="_blank" href="https://beian.miit.gov.cn/">京ICP备19000636号-1</a>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props:{
        isPhone:{
            type:Boolean,
            default:false
        }
    },
    data() {
    //这里存放数据
        return {
            wxsrc:require('../../../assets/images/showProduct/wx-code1.png')
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>

<style src="../pc.css" scoped></style>
<style src="../phone.css" scoped></style>
<style lang='less' scoped>
.icp{
    position: absolute;
    bottom: 27px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 15px;
    color: #7e8283;
}
</style>
